import React from 'react';

import styles from './DatePickers.module.scss';

// Dependency-free placeholder shown by next/dynamic while the real DatePickers (and its
// @material-ui/pickers + @date-io/date-fns bundle) loads, so the two date fields don't pop in
// and shift the rest of the filters panel once the chunk arrives. Must not import DatePickers.tsx
// or anything from @material-ui/pickers, otherwise it would pull that bundle back into the main
// chunk and defeat the point of lazy-loading it.
const DatePickersSkeleton = () => (
  <>
    <div className={styles.container}>
      <div className={styles.skeletonInput} aria-hidden="true" />
    </div>
    <div className={styles.container}>
      <div className={styles.skeletonInput} aria-hidden="true" />
    </div>
  </>
);

export default DatePickersSkeleton;
